const router_modular = [
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/login.vue"),
    // import(/* webpackChunkName: "about" */ "@/views/fillingInformationEnd.vue"),
  },
  {
    path: "/loginZyx",
    name: "loginZyx",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/loginZyx.vue"),
  },
  {
    path: "/gasInfo",
    name: "gasInfo",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/gasInfo.vue"),
    // import(/* webpackChunkName: "about" */ "@/views/fillingInformationEnd.vue"),
  },
  {
    path: "/gasInfoZyx",
    name: "gasInfoZyx",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/gasInfoZyx.vue"),
  },
  {
    path: "/fillingInformation",
    name: "fillingInformation",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/fillingInformation.vue"),
    // import(/* webpackChunkName: "about" */ "@/views/fillingInformationEnd.vue"),//20260112测试环境打开
  },
  {
    // 补录2024-2025年数据补录页面
    path: "/fillingInformationAdditional",
    name: "fillingInformationAdditional",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/fillingInformationAdditional.vue"),
    // import(/* webpackChunkName: "about" */ "@/views/fillingInformationEnd.vue"),//20260112测试环境打开
  },
  {
    path: "/fillingInformationEdit",
    name: "fillingInformationEdit",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/fillingInformationEdit.vue"),
    // import(/* webpackChunkName: "about" */ "@/views/fillingInformationEnd.vue"),//20260112测试环境打开
  },
  {
    path: "/fillingInformationFinish",
    name: "fillingInformationFinish",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/fillingInformationFinish.vue"
      ),
  },
  {
    path: "/fillingInformationFinishNew",
    name: "fillingInformationFinishNew",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/fillingInformationFinishNew.vue"
        ),
  },
  {
    path: "/fullDetail",
    name: "fullDetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/fullDetail.vue"),
  },
  {
    path: "/fullDetailZyx",
    name: "fullDetailZyx",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/fullDetailZyx.vue"),
  },
  {
    path: "/fillingInformationEnd",
    name: "fillingInformationEnd",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/fillingInformationEnd.vue"),
  },



  //企业列表   中油协官网--PC端
  {
    path: "/oilStationListPC",
    name: "oilStationList",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/pcEntList.vue"),
  },
  //企业列表   中油协官网--H5端
  {
    path: "/oilStationListH5",
    name: "oilStationList",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/h5EntList.vue"),
  },
  //企业列表详情   中油协官网--H5端
  {
    path: "/fullDetailH5",
    name: "oilStationListDetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/fullDetailH5.vue"),
  },
  //企业列表详情   中油协官网--PC端
  {
    path: "/fullDetailPC",
    name: "oilStationListDetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/fullDetailPC.vue"),
  },
];
export default router_modular;
